<section class="loading-section">
  <div class="text-center">
    <img class="loading-img" src="/assets/coinmate_logo_short.svg" alt="Coinmate logo" />
    <div class="loading-section">
      <h2 class="cm-paragraph-large !mb-0">{{ 'shared.common.loading' | translate }}</h2>
      <svg-icon class="filter-blue" src="/assets/icons/icon-spinner.svg"></svg-icon>
    </div>
  </div>
</section>

<div class="cm-double-section-bg-left">
  <img src="/assets/img/bg-left.svg" class="block" alt="" />
</div>
<div class="cm-double-section-bg-right">
  <img src="/assets/img/bg-right.svg" class="block" alt="" />
</div>
<div class="cm-double-section-bg-center">
  <img src="/assets/img/bg-center.svg" class="block" alt="" />
</div>
